import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
var HomeLayout = function () {
    return (_jsxs("div", { className: "h-screen w-full overflow-hidden bg-appBg text-ink", children: [_jsx(Navbar, {}), _jsx("main", { className: "h-[calc(100vh-60px)] w-full overflow-hidden bg-appBg", children: _jsx(Outlet, {}) })] }));
};
export default HomeLayout;
